<span>
  @if (icon()) {
    <mat-icon [color]="icon() === EsvgFiles.correct ? 'accent' : 'warn'" [svgIcon]="icon()"/>
  }

  {{ params.value }}
</span>
